// @flow

import styled from "styled-components";

import spacingExtender from "./spacingExtender";
import { fullColorExtender } from "./colors";

const Flex = styled.div`
  display: flex;
  flex: ${({ flex = 1 }) => flex};
  flex-direction: ${({ flexDirection = "row" }) => flexDirection};
  align-items: ${({ alignItems = "center" }) => alignItems};
  justify-content: ${({ justifyContent = "center" }) => justifyContent};
  width: ${({ width = "100%" }) => width};
  ${({ boxShadow, theme }) => (boxShadow ? { boxShadow: theme.shadow } : "")};
  ${spacingExtender};
  ${fullColorExtender};
`;

export default Flex;



// WEBPACK FOOTER //
// ./src/common/flex.js